<div class="mx-auto flex w-full max-w-6xl flex-col gap-6">
	<div>
		<h1 class="text-3xl font-bold" [translate]>Admin Dashboard</h1>
		<p class="text-base-content/60 mt-2" [translate]>Overview of platform activity and admin tools.</p>
	</div>

	@if (usersRepository.currentProfile(); as currentUser) {
		@if (!currentUser.emailVerified) {
			<div class="alert alert-warning">
				<div class="flex w-full flex-col items-start gap-3 md:flex-row md:items-center md:justify-between">
					<div>
						<div class="font-semibold" [translate]>Your admin email is not verified yet.</div>
						<div class="text-sm opacity-80" [translate]>Please verify your email address to unlock features that require a verified account.</div>
					</div>
					<button
						class="btn btn-sm btn-warning"
						[disabled]="isEmailVerificationLoading()"
						(click)="sendEmailVerification()"
					>
						@if (isEmailVerificationLoading()) {
							<span class="loading loading-spinner loading-xs"></span>
						}
						<span [translate]>Send verification email</span>
					</button>
				</div>
			</div>
		}
	}

	<div class="stats stats-vertical sm:stats-horizontal bg-base-100 border-base-200 w-full border shadow-sm">
		@for (statistic of statistics; track statistic.path + statistic.label()) {
			<a class="stat" [routerLink]="statistic.path">
				<div class="stat-title">{{ statistic.label() }}</div>
				@if (statistic.count(); as statisticCount) {
					<div
						class="stat-value"
						[class.text-error]="statistic.isAlert && statisticCount > 0"
					>
						{{ statisticCount }}
					</div>
				} @else if (statistic.count() === 0) {
					<div class="stat-value">0</div>
				} @else {
					<div class="stat-value"><span class="loading loading-dots loading-md"></span></div>
				}
			</a>
		}
	</div>

	<div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
		@for (navigationCard of navigationCards; track navigationCard.path) {
			<a
				[routerLink]="navigationCard.path"
				class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors"
			>
				<div class="text-lg font-semibold">{{ navigationCard.label() }}</div>
				<p class="text-base-content/60 mt-2 text-sm">{{ navigationCard.description() }}</p>
			</a>
		}
	</div>
</div>
